// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ScenesFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="m36.755 25.054 7.24 15.389-2.532 4.733-3.598-2.371a1.996 1.996 0 0 0-2.201 0l-3.617 2.384-2.607-4.747 7.315-15.388ZM87.24 74.64 64.497 34.469c-.356-.63-1.01-.973-1.75-1.015a2.004 2.004 0 0 0-1.74 1.03L52.68 49.508 38.574 19.524a2 2 0 0 0-1.805-1.149h-.004a2 2 0 0 0-1.806 1.142L8.694 74.766a1.998 1.998 0 0 0 1.807 2.858h52.246l.009.001H85.5a1.999 1.999 0 0 0 1.74-2.985Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default ScenesFilled;
